// extracted by mini-css-extract-plugin
export var attachment = "_r3-a";
export var emailContainer = "_r3-4";
export var emailContentPaddedContainer = "_r3-b";
export var emailHeader = "_r3-6";
export var emailIframe = "_r3-3";
export var emailInfoIcon = "_r3-9";
export var emailShortenedSummary = "_r3-e";
export var infoDropdown = "_r3-0";
export var infoRowBoundedContent = "_r3-d";
export var internal = "_r3-5";
export var merchant = "_r3-8";
export var messageInputContainer = "_r3-h";
export var normal = "_r3-7";
export var replyCard = "_r3-f";
export var subtleButton = "_r3-1";
export var subtleButtonIconContainer = "_r3-2";
export var toggleViewRepliesButton = "_r3-c";
export var wrappingText = "_r3-g";